export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9202.ee402d99.jpg";